var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tooltip-btn',{attrs:{"input-value":_vm.settings,"icon":"$mdiCogOutline","path":"settings"},on:{"click":function($event){_vm.settings = !_vm.settings}}})
}
var staticRenderFns = []

export { render, staticRenderFns }